import { MouseEvent } from "react";
import withValidation from "./withValidation.js";
import { trns, removeSpaces } from "../helper.js";
import { Item, HelpBlock, Button, FormGroup, Input, ControlLabel } from "ui-components";

type Props = {
  className?: string;
  placeholder?: string;
  label?: string;
  help?: string;
  value: string;
  handleChange: (e?: string) => void;
  suggestions: string[];
  populateLogin: (e: string) => void;
  error?: string;
  type?: string;
  req?: boolean;
  noAutoComplete?: boolean;
};

const TextSuggestion = ({
  className,
  label,
  error,
  type,
  placeholder,
  handleChange,
  help,
  value,
  req,
  suggestions,
  populateLogin,
  noAutoComplete,
}: Props) => (
  <FormGroup className={className} validationState={error}>
    {label && (
      <ControlLabel forId={removeSpaces(label)}>
        {label} {req && "*"}
      </ControlLabel>
    )}

    <Input
      placeholder={placeholder}
      onChange={handleChange}
      value={value}
      autoComplete={noAutoComplete ? "off" : undefined}
    />

    {help && <HelpBlock>{help}</HelpBlock>}

    {suggestions && suggestions.length > 0 && value && (
      <Item className="suggestions">
        {trns("IDS_LOGINBOX_SUGGESTIONS", "Suggestions")}:{" "}
        {suggestions.map((s, i) => (
          <Button
            type="button"
            asLink
            key={i}
            onClick={(e: MouseEvent) => {
              populateLogin(s);
            }}
          >
            {s}
          </Button>
        ))}
      </Item>
    )}
  </FormGroup>
);

export default withValidation(TextSuggestion);
